import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useApi } from "@/lib/api";

const inp = "h-10 px-3 rounded-lg bg-surface border border-line text-sm text-ink focus:outline-none focus:border-[var(--q)]";
const NAMA = { percuma: "Percuma", asas50: "RM29 · 50 carian", tanpahad: "RM49 · tanpa had" };
const TZ = { timeZone: "Asia/Kuala_Lumpur", day: "numeric", month: "short", year: "numeric" };
const masa = (iso) => new Date(iso).toLocaleString("ms-MY", { ...TZ, hour: "2-digit", minute: "2-digit" });
const tarikh = (iso) => new Date(iso).toLocaleDateString("ms-MY", TZ);
const pelan = (x) => `${NAMA[x.plan] || x.plan}${x.plan_expires_at ? ` (tamat ${tarikh(x.plan_expires_at)})` : ""}`;

export const AdminLog = () => {
  const api = useApi();
  const [items, setItems] = useState(null);
  const [f, setF] = useState({ q: "", dari: "", hingga: "" });
  useEffect(() => {
    const t = setTimeout(() => api("get", "/admin/log", null, { params: f }).then(setItems).catch(() => setItems([])), 250);
    return () => clearTimeout(t);
  }, [api, f]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-3 items-end" data-testid="admin-log-filters">
        <label className="text-xs text-mute flex flex-col gap-1">Emel pengguna<input value={f.q} onChange={set("q")} placeholder="Cari emel…" className={`${inp} w-64`} data-testid="admin-log-search" /></label>
        <label className="text-xs text-mute flex flex-col gap-1">Dari<input type="date" value={f.dari} onChange={set("dari")} className={inp} data-testid="admin-log-dari" /></label>
        <label className="text-xs text-mute flex flex-col gap-1">Hingga<input type="date" value={f.hingga} min={f.dari || undefined} onChange={set("hingga")} className={inp} data-testid="admin-log-hingga" /></label>
        {(f.q || f.dari || f.hingga) && <button onClick={() => setF({ q: "", dari: "", hingga: "" })} className="h-10 px-4 text-sm text-mute hover:text-ink" data-testid="admin-log-reset">Set semula</button>}
      </div>
      {!items ? <Loader2 className="animate-spin text-q" /> : (
    <div className="rounded-xl border border-line overflow-x-auto surface" data-testid="admin-log">
      <Table>
        <TableHeader><TableRow><TableHead>Masa</TableHead><TableHead>Admin</TableHead><TableHead>Pengguna</TableHead><TableHead>Perubahan</TableHead><TableHead>Nota</TableHead></TableRow></TableHeader>
        <TableBody>
          {items.map((l) => (
            <TableRow key={l.id} data-testid={`admin-log-row-${l.id}`}>
              <TableCell className="text-xs font-mono-data whitespace-nowrap">{masa(l.created_at)}</TableCell>
              <TableCell className="text-xs">{l.by}</TableCell>
              <TableCell className="text-sm">{l.email}</TableCell>
              <TableCell className="text-xs">{pelan(l.dari)} → <strong>{pelan(l.ke)}</strong>{l.ke.disambung && <div className="text-mute">disambung dari tempoh sedia ada · mula {tarikh(l.ke.mula)}</div>}</TableCell>
              <TableCell className="text-xs">{l.nota}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {items.length === 0 && <p className="p-4 text-sm text-mute" data-testid="admin-log-empty">Tiada rekod.</p>}
    </div>
      )}
    </div>
  );
};
